module.exports = __webpack_public_path__ + "static/assets/b3b4397b2fd32e3960c0b66527938878.svg";